<template>
  <div id="app" ref="app">
    <attract-loop v-if="showLoop" :video="videoURL" ref="video" @click.native="onAttractClick" @ended="onLoopEnd"></attract-loop>
    <col-imaging v-if="!showLoop" :ui-mode="uiMode" :placeholder="placeholder" :placeholderVideo="placeholderVideo" @wheel-reveal="onWheelRevealed" @wheel-hide="onWheelHidden" @trigger-loop="onTriggerLoop" @interaction="onInteraction" @fullscreen="goFullScreen"></col-imaging>
    <div class="stats">{{ this.stats }}</div>
    <div class="idle-settings" v-if="showIdleSettings">
      <div class="idle-btn" @click="setIdleTime(1)" :data-active="(currentIdleTime == 1)">1</div>
      <div class="idle-btn" @click="setIdleTime(3)" :data-active="(currentIdleTime == 3)">3</div>
      <div class="idle-btn" @click="setIdleTime(5)" :data-active="(currentIdleTime == 5)">5</div>
      <div class="idle-btn" @click="setIdleTime(8)" :data-active="(currentIdleTime == 8)">8</div>
      <div class="idle-btn" @click="setIdleTime(15)" :data-active="(currentIdleTime == 15)">15</div>
    </div>

    <div class="fullscreen" @click="goFullScreen" v-if="showFullscreenButton">
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" class="fullscreen-icon" viewBox="0 0 21 21">
        <path id="Icon_material-fullscreen" data-name="Icon material-fullscreen" d="M10.5,21h-3v7.5H15v-3H10.5Zm-3-6h3V10.5H15v-3H7.5Zm18,10.5H21v3h7.5V21h-3ZM21,7.5v3h4.5V15h3V7.5Z" transform="translate(-7.5 -7.5)"/>
      </svg>
      <span class="fullscreen-label">Fullscreen</span>
    </div>
    <div class="close-app-button" @click="onCloseApp" v-if="showBackButton">

      <span class="fullscreen-label">Back</span>
    </div>
    
  </div>
</template>

<script>

import AttractLoop from "./components/AttractLoop";
import ColImaging from "./components/ColImaging";
import fscreen from "fscreen"

export default {
  components: {
    AttractLoop, ColImaging
  },

  mounted: function(){

    //document.addEventListener('fullscreenchange', this.onScreenChange);

    fscreen.addEventListener('fullscreenchange', this.onScreenChange);

    if(this.$route && this.$route.query.placeholder){

      var placeholderLink  = this.$route.query.placeholder;
      if(placeholderLink.indexOf(".mp4") > -1){
        //this is a video, use the video placeholder
        this.placeholderVideo = "graphics/"+this.$route.query.placeholder;

      }else{
        this.placeholder = "graphics/"+this.$route.query.placeholder;
      }


    }

    if(this.$route.query.fsbtn == "1"){
      this.showFullscreenButton = true;
    }

    if(this.$route.query.back){
      this.showBackButton = true;
    }

    if(this.$socket){
        this.$socket.on('welcome', ()=> {
            //console.log(data);
            //socket.emit('my other event', { my: 'data' });
        });

        this.$socket.on('action all', ()=>{
            //console.log("action received", actionInfo);

        });

        this.$socket.on('idle', ()=>{

            this.onIdle();
            //let msgDelay = Date.now() - data.time ;

            //this.stats = msgDelay+"ms";
        });

        this.$socket.on('awake', ()=>{

            //changeColor(data.color);
            this.onWake();

        });
    }


  },

  data: function(){
    return {
      showLoop: false,
        isFullScreen: false,
        uiMode: "wheel",
        stats: "",
        showIdleSettings: false,
        currentIdleTime: 3,
        placeholder: undefined,
        placeholderVideo: undefined,
        showFullscreenButton: false,
        showBackButton: false
    }
  },

  methods: {

    setIdleTimer: function(value){
      if(this.$socket){
        this.$socket.emit("idletime", { value: value });
      }
    },

    onCloseApp: function(){
      window.close();
    },

      onInteraction: function(){
          if(this.$socket){
              //console.log('interaction');
              this.$socket.emit('interaction');
          }
      },

      onLoopEnd: function(){
          ////console.log("loop ended");
          this.onAttractClick();
      },

      onWheelRevealed: function(){
        //console.log("wheel revealed");
      },

      onWheelHidden: function(){
          //console.log("wheel hidden");
      },

      onScreenChange: function(){
        ////console.log(e);
        //console.log(window.innerHeight, screen.height);

          if( window.innerHeight == screen.height) {
              // browser is fullscreen
              //console.log("Is full screen")
          }else{
              //console.log("Is not full screen")
          }
      },

    onTriggerLoop: function(){
      if(this.$socket){
        this.$socket.emit('forceidle');
      }
    },

    onIdle: function(){
       this.showLoop = true;

    },

    onAttractClick: function(){
        if(this.$socket){
          this.$socket.emit('awaken');
        }else{
            this.onWake();
        }




    },

      goFullScreen: function(){
        //console.log("refs", this.$refs.app);
        if( fscreen.fullscreenElement === this.$refs.app) {
          // browser is fullscreen
          fscreen.exitFullscreen();
          this.isFullScreen = false;
        }else{

          fscreen.requestFullscreen(this.$refs.app);

          //this.$refs.app.requestFullscreen();
          this.isFullScreen = true;
        }

      },

    onWake: function(){
      this.showLoop = false;
    },
  },

    computed: {
      videoURL: function(){
          if(this.$route.query['video']){
              return this.$route.query['video']
          }else{
              return "middle.mp4"
          }

      },

    }

  
}
</script>

<style>

  @font-face {
    font-family: "Myriad";
    font-weight: normal;
    src: url("fonts/myriad-text.ttf") format("truetype");
  }

  @font-face {
    font-family: "Myriad";
    font-weight: bold;
    src: url("fonts/myriad-bold.ttf") format("truetype");
  }

  body {
    margin: 0;
    padding: 0;
    background-color: black;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }



#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1vw;
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 0;
  padding-bottom: calc(100% * (9/16));
  background-color: black;


  --wireframe-dark: #427BAC;
  --wireframe-bright:  #FAFBFC;
  --wireframe: #90d5fc;

  --brand-red: #cb2026;
  --brand-black: #000;
  --brand-gray: #555;
  --brand-gray-light: #ccc;
  --brand-white: #fff;
  --brand-transparent: rgba(0,0,0,0);


}

  .fullscreen {
    color: white;
    cursor: pointer;
    position: absolute;
    z-index: 100;
    align-items: center;
    padding: 0.5em;
    display: flex;
    align-items: center;

    right: 5em;
    top: 0em;

    background-color: rgba(255,255,255,0.3);
    color: white;
    fill: white;
    border-bottom-left-radius: 0.25em;
    border-bottom-right-radius: 0.25em;


  }

  .close-app-button {
    color: white;
    cursor: pointer;
    position: absolute;
    z-index: 100;
    align-items: center;
    padding: 0.5em;
    display: flex;
    align-items: center;

    left: 5em;
    top: 0em;

    background-color: rgba(255,255,255,0.3);
    color: white;
    fill: white;
    border-bottom-left-radius: 0.25em;
    border-bottom-right-radius: 0.25em;


  }

  .fullscreen:hover {
    opacity: 1.0;
  }


  .fullscreen-icon {

    height: 1em;
  }

  .fullscreen-label {
    font-size: 1em;
    display: inline-block;
    margin-left: 0.25em;
  }

  .stats {
    position: absolute;
    bottom: 1em;
    right: 1em;
    font-size: 0.7em;
    color: #888;

  }

  .idle-settings {
    position: absolute;
    display: flex;
    top: 2em;
    left: 2em;

  }

  .idle-btn {
    width: 3em;
    height: 3em;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white;
    color: white;
    border-radius: 100%;
    margin: 0.5em;
    font-size: 0.5em;
  }

  .idle-btn[data-active="true"]{
    background-color: white;
    color: black;
  }


</style>
